interface PlannedProps {
  kicker: string;
  title: string;
  body: string;
  items: Array<{ name: string; desc: string; done?: boolean }>;
}

export function Planned({ kicker, title, body, items }: PlannedProps) {
  return (
    <section className="planned">
      <span className="planned__kicker">{kicker}</span>
      <h2 className="planned__title">{title}</h2>
      <p className="planned__body">{body}</p>
      <ul className="planned__list">
        {items.map((item) => (
          <li className={`planned__item ${item.done ? "planned__item--done" : ""}`} key={item.name}>
            <span className="planned__mark">{item.done ? "✓" : "·"}</span>
            <span>
              <span className="planned__name">{item.name}</span>
              <span className="planned__desc">{item.desc}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
